import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import EditIcon from '@mui/icons-material/Edit';

const DriverRiderBonusView = () => {
  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>
        Rider / Driver Bonus
      </Typography>
      <Box sx={{ mt: 3, display: 'flex' }}>
        <Box
          sx={{
            background: '#C7EBFF',
            width: '200px',
            height: '50px',
            p: 3,
            borderRadius: '10px',
          }}
        >
          <Typography>10 order</Typography>
          <Typography variant="h5">Get 10% bonus</Typography>
        </Box>
        <Box
          sx={{
            background: '#C1FEC6',
            width: '200px',
            height: '50px',
            p: 3,
            borderRadius: '10px',
            ml: 5,
          }}
        >
          <Typography>15 order</Typography>
          <Typography variant="h5">Get 12% bonus</Typography>
        </Box>
        <Box
          sx={{
            background: '#FFDB927A',
            width: '200px',
            height: '50px',
            p: 3,
            borderRadius: '10px',
            ml: 5,
          }}
        >
          <Typography>20 order</Typography>
          <Typography variant="h5">Get 15% bonus</Typography>
        </Box>
      </Box>
      <Box sx={{ mt: 4 }}>
        <TableContainer>
          <Table>
            <TableHead sx={{ background: '#F4F6F8' }}>
              <TableRow>
                <TableCell sx={{ borderBottom: 'none' }}>No</TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="center">
                  Order Target
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="center">
                  Bonus
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="right">
                  Update by
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="right">
                  Last update
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ borderBottom: 'none' }}>1</TableCell>
                <TableCell sx={{ borderBottom: 'none', textAlign: 'center' }} align="center">
                  <Box
                    sx={{
                      backgroundColor: '#00A8F3',
                      width: '50px',
                      m: 'auto',
                      p: 1,
                      borderRadius: '10px',
                    }}
                  >
                    <Typography color='#fff'>10</Typography>
                  </Box>
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="center">
                  <Box
                    sx={{
                      backgroundColor: '#00A8F3',
                      width: '50px',
                      m: 'auto',
                      p: 1,
                      borderRadius: '10px',
                    }}
                  >
                    <Typography color='#fff'>10%</Typography>
                  </Box>
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="right">
                  Phat
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="right">
                  13:43-2/4/2024
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="right">
                  <EditIcon />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ borderBottom: 'none' }}>2</TableCell>
                <TableCell sx={{ borderBottom: 'none', textAlign: 'center' }} align="center">
                  <Box
                    sx={{
                      backgroundColor: '#00A8F3',
                      width: '50px',
                      m: 'auto',
                      p: 1,
                      borderRadius: '10px',
                    }}
                  >
                    <Typography color='#fff'>15</Typography>
                  </Box>
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="center">
                  <Box
                    sx={{
                      backgroundColor: '#00A8F3',
                      width: '50px',
                      m: 'auto',
                      p: 1,
                      borderRadius: '10px',
                    }}
                  >
                    <Typography color='#fff'>12%</Typography>
                  </Box>
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="right">
                  Phat
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="right">
                  13:43-2/4/2024
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="right">
                  <EditIcon />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ borderBottom: 'none' }}>3</TableCell>
                <TableCell sx={{ borderBottom: 'none', textAlign: 'center' }} align="center">
                  <Box
                    sx={{
                      backgroundColor: '#00A8F3',
                      width: '50px',
                      m: 'auto',
                      p: 1,
                      borderRadius: '10px',
                    }}
                  >
                    <Typography color='#fff'>20</Typography>
                  </Box>
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="center">
                  <Box
                    sx={{
                      backgroundColor: '#00A8F3',
                      width: '50px',
                      m: 'auto',
                      p: 1,
                      borderRadius: '10px',
                    }}
                  >
                    <Typography color='#fff'>15%</Typography>
                  </Box>
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="right">
                  Phat
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="right">
                  13:43-2/4/2024
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }} align="right">
                  <EditIcon />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};
export default DriverRiderBonusView;
